import React from 'react';
import NotableTrendCard from './NotableTrendCard';
import BarChartIcon from '@mui/icons-material/BarChart';

interface Trend {
  Trend?: string;
  TrendType?: 'positive' | 'negative';
}

interface NotableTrendsSectionProps {
  trends: (Trend | string)[];
}

const NotableTrendsSection: React.FC<NotableTrendsSectionProps> = ({ trends }) => {
  if (!trends || trends.length === 0) {
    return null;
  }

  return (
    <div style={{
      background: '#fff',
      borderRadius: '12px',
      padding: '2rem',
      //marginBottom: '1.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      borderLeft: '4px solid #9f7aea',
      breakInside: 'avoid'
    }}>
      <h2 style={{ color: '#9f7aea', marginBottom: '1rem', fontSize: '1.5rem', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
        <BarChartIcon style={{ marginRight: '8px' }} />
        Notable Trends
      </h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {trends.map((trend, index) => (
          <NotableTrendCard key={index} trend={trend} />
        ))}
      </ul>
    </div>
  );
};

export default NotableTrendsSection;
